import { combineReducers } from "redux";
import LoginReducer from "./Login/reducer";
import serviceReducer from "./Service/reducer";
import agencyReducer from "./agency/reducer";
import driversReducer from "./drivers/reducers";
import disputeReducer from "./dispute/reducer";
import SettingsReducer from "./Settings/reducer";
import FaqReducer from "./Faq/reducer";
import ContentPageReducer from "./Content/reducer";
import vendorReducer from "./Vendor/reducer";

const rootReducer = combineReducers({
  login: LoginReducer,
  service: serviceReducer,
  agency: agencyReducer,
  driver: driversReducer,
  dispute: disputeReducer,
  Setting: SettingsReducer,
  FaqReducer: FaqReducer,
  ContentPageReducer: ContentPageReducer,
  vendor: vendorReducer,
});

export default rootReducer;
